import { Account } from "library/accounts/types";
import { ActionMap } from "library/ActionMap";
import { FullAddress } from "library/api/address/types.generated";
import { Product, ProductScheme } from "library/hooks/types";

export type LocationState = {
  account: Account;
  product: Product;
};

export type CtaType = ActionType.REPORT_LOST_STOLEN | ActionType.REPORT_DAMAGED;

export type ReportLostStolenOrDamagedPayload = {
  request_type: "REPLACE" | "REISSUE";
};

export enum Pages {
  REPORT_LOST_STOLEN_OR_DAMAGED = "REPORT_LOST_STOLEN_OR_DAMAGED",
  UNAVAILABLE = "UNAVAILABLE",
  REPORT_LOST_STOLEN_CONFIRMATION = "REPORT_LOST_STOLEN_CONFIRMATION",
  REPORT_DAMAGED_CONFIRMATION = "REPORT_DAMAGED_CONFIRMATION",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export enum ActionType {
  REPORT_LOST_STOLEN = "REPORT_LOST_STOLEN",
  REPORT_DAMAGED = "REPORT_DAMAGED",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export type State =
  | {
      page: Pages.ERROR | Pages.UNAVAILABLE | Pages.SUCCESS;
    }
  | {
      page:
        | Pages.REPORT_LOST_STOLEN_CONFIRMATION
        | Pages.REPORT_DAMAGED_CONFIRMATION;
      scheme: ProductScheme;
      cardEndsWith: string;
      address: FullAddress;
      type: CtaType;
      lostStolenDamagedUrl: string;
    }
  | {
      page: Pages.REPORT_LOST_STOLEN_OR_DAMAGED;
      scheme: ProductScheme;
      cardEndsWith: string;
      lostStolenDamagedUrl: string;
      personalDetailsUrl: string;
      token: string;
    };

export type Payload = {
  [ActionType.REPORT_LOST_STOLEN]: {
    address: FullAddress;
    scheme: ProductScheme;
    cardEndsWith: string;
    lostStolenDamagedUrl: string;
    type: CtaType;
  };
  [ActionType.REPORT_DAMAGED]: {
    address: FullAddress;
    scheme: ProductScheme;
    cardEndsWith: string;
    lostStolenDamagedUrl: string;
    type: CtaType;
  };
};

export type Action = ActionMap<ActionType, Payload>;
